// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * UserRoleAttributes type.
 * @typedef {object} UserRoleAttributes
 * @property {string} id - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} role - Attribute value.
 * @property {string} translatedRole - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted by UserRoleCreateAttributes.
 * @typedef {object} UserRoleCreateAttributes
 * @property {UserRoleAttributes["role"] | null} [role] - Permitted role value.
 * @property {UserRoleAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by UserRoleUpdateAttributes.
 * @typedef {object} UserRoleUpdateAttributes
 * @property {UserRoleAttributes["role"] | null} [role] - Permitted role value.
 * @property {UserRoleAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for UserRole.
 * @augments {FrontendModelBase<UserRoleAttributes, UserRoleCreateAttributes, UserRoleUpdateAttributes, UserRoleAttributes["id"], string>}
 */
class UserRole extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "UserRole",
      attributes: [
        "id",
        "createdAt",
        "role",
        "translatedRole",
        "updatedAt",
        "userId",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      user: "User",
    }
  }

  /** @returns {UserRoleAttributes["id"]} - Attribute value. */
  id() { return /** @type {UserRoleAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {UserRoleAttributes["id"] | null} newValue - New attribute value.
   * @returns {UserRoleAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {UserRoleAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {UserRoleAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {UserRoleAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {UserRoleAttributes["role"]} - Attribute value. */
  role() { return /** @type {UserRoleAttributes["role"]} */ (this.readAttribute("role")) }

  /**
   * @param {UserRoleAttributes["role"] | null} newValue - New attribute value.
   * @returns {UserRoleAttributes["role"] | null} - Assigned value.
   */
  setRole(newValue) { return /** @type {UserRoleAttributes["role"] | null} */ (this.setAttribute("role", newValue)) }

  /** @returns {UserRoleAttributes["translatedRole"]} - Attribute value. */
  translatedRole() { return /** @type {UserRoleAttributes["translatedRole"]} */ (this.readAttribute("translatedRole")) }

  /**
   * @param {UserRoleAttributes["translatedRole"] | null} newValue - New attribute value.
   * @returns {UserRoleAttributes["translatedRole"] | null} - Assigned value.
   */
  setTranslatedRole(newValue) { return /** @type {UserRoleAttributes["translatedRole"] | null} */ (this.setAttribute("translatedRole", newValue)) }

  /** @returns {UserRoleAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {UserRoleAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {UserRoleAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {UserRoleAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {UserRoleAttributes["userId"] | null} newValue - New attribute value.
   * @returns {UserRoleAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {UserRoleAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<UserRole, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<UserRole, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(UserRole)

export {UserRole}

export default UserRole
